module.exports = __webpack_public_path__ + "c604af8c7d30ac606372462dd41a2bbd.pdf";